/**
 * 新增 编辑
 * @author xyguo
 * @description  新增/编辑
 * @Date  2021/7/20
 */
import React, { Component } from 'react';
import { Card, Form } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm, WizClassifySelectRe, WizAuthority } from '@/containers/common';
import '@/styles/containers/online/live/style.less';
import { DatePicker } from 'antd'
import moment from "moment";
const { RangePicker } = DatePicker;
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole" } })
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["4"] } })
const remoteAuth = WizTableForm.Config.remoteAuth(this, { apiParams: { type: 1 } });
let { WizAvatarUpload, ossFileUtils, WizFileUpload } = framework_tool

let {
  WizButton,
  WizTooltip,
  WizInput,
  WizIcon,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  Wizmessage,
  WizSelect,
} = component_tool;
let WizForm = Form
let Item = Form.Item

class OrgRemoteEvaluationDetailForm extends Component {

  constructor(props) {
    super(props);
    if (props.onRef) {//如果父组件传来该方法 则调用方法将子组件this指针传过去
      props.onRef(this)
    }
    let { initialValue } = props;
    this.state = {
      type: initialValue && initialValue.liveType ? initialValue.liveType : 1,
      wizAuthorityKey: 'wizAuthorityKey',//用于处理wizAuthority组件重置不生效问题
      showNoticeStart: false,
      showNoticeEnd: true,
      remoteAuthId: initialValue && initialValue.remoteAuthId ? initialValue.remoteAuthId : undefined,
      orgId: initialValue && initialValue.orgId ? initialValue.orgId : undefined,
      personIdList: initialValue && initialValue.personIdList ? initialValue.personIdList : [],
      personInfoAuthNew: initialValue && initialValue.personInfoList ? initialValue.personInfoList : [],
      authCmd: [],
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
      this.clearWizCallBack = [];
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips} >
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  setAuthValue = (authInfo) => { //定义方法
    let personIdList = [];
    let personInfoAuthNew = [];
    if (authInfo && authInfo instanceof Array && authInfo.length > 0) {
      authInfo.forEach(personInfo => {
        const { personId, userId, fullName } = personInfo;
        personIdList.push(personId);
        personInfoAuthNew.push({ id: personId, key: personId, ...personInfo })
      })
    }
    this.props.form.setFieldsValue({ authCmd: personIdList })
    this.setState({
      personIdList: personIdList,
      personInfoAuthNew: personInfoAuthNew,
    })
  }

  showLiveResources = () => {
    let liveResources = <Item style={{ marginBottom: 0, display: 'inline-block', }}>
                          <font style={{ 'color': 'red' }}>剩余资源提醒:{this.props.checkDateInfo} </font>
                      </Item>
    return this.state.showNoticeStart ? liveResources : undefined
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const { getFieldDecorator } = this.props.form;
    let authCmdItem = <Item label="受众" required >
      {getFieldDecorator('authCmd', {
        rules: [{ required: true, message: '请选择受众', }],
        initialValue: this.state.personIdList,
      })(
        <WizTableForm key={this.state.wizAuthorityKey + this.state.personIdList} disabled={!this.state.orgId || !this.state.remoteAuthId}
          {...WizTableForm.Config.user(this, { apiParams: { state: 1, organizationIdList: [this.state.orgId] } })}
          initRows={this.state.personInfoAuthNew }
          onClearWiz={this._onClearWiz.bind(this)}
        />
      )}
    </Item>;
    let showLiveResources = this.showLiveResources();
    let base01 = [
      <Item label="检核场次">
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入直播名称' }],
          initialValue: this.initialValue.name,
        })(<WizInput maxlength={30} placeholder='请输入直播名称,最多输入30个字' />)}
      </Item>,
      <Item label="直播分类">
        {getFieldDecorator('liveCategoryId', {
          rules: [{ type: 'array' }, { required: true, message: '请选择直播分类' }],
          initialValue: this.initialValue.liveCategoryId ? [this.initialValue.liveCategoryId] : [],
        })(
          <WizClassifySelectRe
            returnKey={true}
            apiProps={{ type: 9, state: 1 }}
            initSelects={this.initialValue.categoryInfo ? this.initialValue.categoryInfo : []}
            wizTreeSelectListProps={{
              itemProps: {
                icon: 'unordered-list',
                title: '直播分类',
                tips: '请选择直播分类'
              },
              multiple: false,
              treeCheckable: false,
              checkable: false,
              showSelectList: true,
              treeProps: { checkStrictly: true }
            }}
            onClearWiz={this._onClearWiz.bind(this)} />
        )}
      </Item>,
      <Item label="评估项目" required >
        {getFieldDecorator('remoteAuthId', {
          rules: [{ required: true, message: '请选择评估项目', }],
          initialValue: this.initialValue.remoteAuthId,
          onChange: (a, b, c) => {
            this.setState({
              remoteAuthId: a,
              wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime()
            }, () => { this.props.getAuthStudent(this.state.remoteAuthId, this.state.orgId) })
          }
        })(<WizTableForm {...remoteAuth} selectType={"radio"} title="选择评估项目" onClearWiz={this._onClearWiz.bind(this)}
          disabled={(this.initialValue.state == 3 || this.initialValue.state == 4) ? true : false} initRows={this.initialValue.remoteAuthInfo ? this.initialValue.remoteAuthInfo : []} />)}
      </Item>,
      <Item label="讲师" required >
        {getFieldDecorator('lectureId', {
          rules: [{ required: true, message: '请选择讲师', }],
          initialValue: this.initialValue.lectureId,
        })(<WizTableForm {...userConfig} selectType={"radio"} title="选择讲师" onClearWiz={this._onClearWiz.bind(this)}
          disabled={(this.initialValue.state == 3 || this.initialValue.state == 4) ? true : false} initRows={this.initialValue.personInfo ? this.initialValue.personInfo : []} />)}
      </Item>,
      <Item label="组织" required >
        {getFieldDecorator('orgId', {
          rules: [{ required: true, message: '请选择组织', }],
          initialValue: this.initialValue.orgId,
          onChange: (a, b, c) => {
            this.setState({
              orgId: a,
              wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime()
            }, () => { this.props.getAuthStudent(this.state.remoteAuthId, this.state.orgId) })
          }
        })(<WizTableForm {...organizationConfig} selectType={"radio"} title="请选择组织" onClearWiz={this._onClearWiz.bind(this)}
          disabled={(this.initialValue.state == 3 || this.initialValue.state == 4) ? true : false} initRows={this.initialValue.orgInfo ? this.initialValue.orgInfo : []} />)}
      </Item>,
      authCmdItem,
      <Item label="检核终端" >
        {getFieldDecorator('authWay', {
          initialValue: this.initialValue.authWay  ? this.initialValue.authWay : 0
        })(
          <WizSelect placeholder="请选择检核终端">
                        <Option value={0}>培训助手</Option>
                        {/* <Option value={1}>企业微信</Option> */}
          </WizSelect>,
        )}
      </Item>,
      <Item label="是否可回看" >
        {getFieldDecorator('lookingBack', {
          initialValue: this.initialValue.lookingBack  ? this.initialValue.lookingBack : 0
        })(
          <WizRadio.Group>
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>,
      <Item label="检核时间" layout="inline" style={{ width: '100%' }}>
      <Item >
        {getFieldDecorator('remoteDate', {
          rules: [{ required: true, message: '请选择检核时间', }],
          initialValue: [moment(this.initialValue.startDate),moment(this.initialValue.endDate)],
          onChange: (form, value, label, extra) => {
            this.setState({
              showNoticeStart: value ? true : false
            })
            let startDate = value && value.length > 0 ? value[0]+":00" : "";
            let endDate = value && value.length > 0 ? value[1]+":00"  : "";
            let ownerId = this.initialValue.ownerId;
            //type ： 0:zoom资源帐户；1：中目资源帐户
            if (startDate && endDate && this.props.checkMeetingDate) {
              this.props.checkMeetingDate(startDate, endDate, ownerId, 1)
            }
          },
        })(<RangePicker key='remoteDate' showTime format="YYYY-MM-DD HH:mm" />)}
      </Item>
      {showLiveResources}
      </Item>,
      <Item label="封面" >
        {getFieldDecorator('img', {
          initialValue: (this.initialValue && this.initialValue.img) ? [
            { fileId: this.initialValue.img }
          ] : [],
        })(
          <WizAvatarUpload
            accept={'.jpg, .jpeg, .png'}
            listType={'picture-card'}
            aspectRatio={2 / 1}
            beforeUpload={(file) => {
              let result = true;
              const isLt1M = file.size / 1024 / 1024 < 0.195;
              if (file.type.indexOf('image/') == -1) {
                Wizmessage.error('只能上传图片类型,请重新选择!');
                result = false;
              } else if (!isLt1M) {
                Wizmessage.error('图片不得超过200k!');
                result = false;
              }
              return result;
            }}
          />
        )}
      </Item>,

    ];
    let zoomBase = this._zoomInteractLive();
    let allBase = [...base01, ...zoomBase];
    return allBase
  }


  /**
   *  zoom类型的直播
   *  Item hasFeedback 展示校验状态图标
   */
  _zoomInteractLive() {
    const formItemTitleLayout = {
      wrapperCol: { span: 16, offset: 4 },
    };
    const { getFieldDecorator } = this.props.form;
    let items = [
      <Item label="直播设置">
        <WizButton title="恢复默认设置" size='small' onClick={e => {
          this._changeInteractLiveValue()
        }}>恢复默认设置</WizButton>
      </Item>,
      <Item {...formItemTitleLayout}>
        <Card>
          <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
            <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'是否自动录制：'}</WizCol>
            <WizCol span={6} className='item-content'>
              {getFieldDecorator('autoRecording', {
                initialValue: this.initialValue.autoRecording ? this.initialValue.autoRecording : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="是否系统自动录制视频">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
            <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
              offset={1} hidden={true}>{'讲师视频：'}</WizCol>
            <WizCol span={6} hidden={true} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
              {getFieldDecorator('hostVideo', {
                initialValue: this.initialValue.hostVideo ? this.initialValue.hostVideo : 0
              })(
                <WizRadio.Group>
                  <WizRadio value={1}>是</WizRadio>
                  <WizRadio value={0}>否</WizRadio>
                </WizRadio.Group>
              )}
              <WizTooltip title="讲师进入课堂时是否打开摄像头">
                <WizIcon type="question-circle-o" />
              </WizTooltip>
            </WizCol>
          </WizRow>
        </Card>
      </Item>
    ]
    return items
  }

  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{ span: 12, offset: 6 }}>
        <WizRow>
          <WizCol span={24} style={{ textAlign: 'center' }}>
            <WizButton style={{ marginLeft: 20 }} title="保存" type="primary" htmlType="submit">保存</WizButton>
            <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>重置</WizButton>
          </WizCol>
        </WizRow>
      </Item>
    )
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {
          this.props.onSubmit(values);
        }
      }
    });
  };

  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let type = this.initialValue && this.initialValue.type ? this.initialValue.type : undefined;
    this.setState({
      type: type,
      wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime(),
      personIdList: [],
      personInfoAuthNew: [],
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  /**
   *
   * 设置直播附属信息值,未传则全部设置默认值
   */
  _changeInteractLiveValue = () => {
    this.props.form.setFieldsValue({
      autoRecording: 0,
      hostVideo: 0,
      participantVideo: 0,
      waitingRoom: 0,
      muteUponEntry: 0,
      joinBeforeHost: 0,
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { title } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <WizCard title={title} icon='0'>
        <WizForm
          key={this.props.formKey}
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(OrgRemoteEvaluationDetailForm);


